export const squidApiBaseUrl = "https://v2.api.squidrouter.com";
